import { FooterCell, Typography } from '@ui-components/neo.tax';
import { CellProps, Column } from 'react-table';

import { RdProject, RdProjectTeamMember } from '@neo.tax/rd/hooks';
import { formatContributorName, HIGHLIGHT_VARIANT } from '@neo.tax/shared';

import { RdTeamMemberAllocation } from '../RdTeamMemberAllocation';

type RdTeamMembersTableColumns = {
  columns: Column<RdProjectTeamMember>[] | null;
};

export const useRdTeamMembersTableColumns = ({
  rdProject,
  teamMembers,
}: {
  teamMembers: RdProjectTeamMember[] | null;
  rdProject: RdProject;
}): RdTeamMembersTableColumns => {
  const numberOfTeamMembers = teamMembers?.length ?? 0;
  const sumOfAllocations = teamMembers?.reduce((a, b) => a + b.allocationPercent, 0) ?? 0;
  const averageProjectAllocationPercent = numberOfTeamMembers === 0 ? 0 : sumOfAllocations / numberOfTeamMembers;

  return {
    columns: [
      {
        id: 'team-member',
        width: 290,
        Header: 'Name',
        accessor: (teamMember: RdProjectTeamMember): RdProjectTeamMember['contributorName'] =>
          teamMember.contributorName,
        Cell: ({ value }: CellProps<RdProjectTeamMember, string>): JSX.Element => (
          <Typography
            title={formatContributorName(value)}
            fontWeight="medium"
            fontSize="sm"
            overflow="hidden"
            whiteSpace="nowrap"
            textOverflow="ellipsis"
          >
            {formatContributorName(value)}
          </Typography>
        ),
        Footer: (): JSX.Element => <FooterCell preText="COUNT" text={numberOfTeamMembers} />,
      },
      {
        id: rdProject.id,
        width: 110,
        Header: '% of Time',
        accessor: (teamMember: RdProjectTeamMember): RdProjectTeamMember => teamMember,
        Cell: ({ value }: CellProps<RdProjectTeamMember, RdProjectTeamMember>): JSX.Element => (
          <RdTeamMemberAllocation rdProject={rdProject} teamMember={value} variant={HIGHLIGHT_VARIANT} />
        ),
        Footer: (): JSX.Element => (
          <FooterCell preText="AVG" text={`${Math.round(averageProjectAllocationPercent)}%`} alignText="end" />
        ),
      },
    ],
  };
};
